import { createSlice } from "@reduxjs/toolkit";


export const faqSlice = createSlice({
    name: 'faq',
    initialState: {
        faqsData: [],
    },
    reducers: {
        setFaqsData: (state, action) => {
            state.faqsData = action.payload
        },
        setUpdateFaqs: (state, action) => {
            const newFaq = action.payload
            const index = state.faqsData?.findIndex((item => (item?._id === newFaq?._id)))
            if (index === -1) {
                state.faqsData.push(action.payload);
            } else {
                state.faqsData[index] = newFaq
            }
        },
        setDeleteFaqs: (state, action) => {
            const newFaq = action.payload
            const index = state.faqsData?.findIndex((item => (item?._id === newFaq?._id)))
            if (index !== -1) {
                state.faqsData.splice(index, 1);
            }
        },
    }
})

export const { setDeleteFaqs, setFaqsData, setUpdateFaqs } = faqSlice.actions

export default faqSlice.reducer